import React from "react";
import { Dropdown, Spinner } from "react-bootstrap";
import { ChevronDown } from "react-bootstrap-icons";

export interface ILanguageOption {
  value: string;
  label: string;
}

interface ILanguageSelectProps {
  value: string;
  options: ILanguageOption[];
  onChange: (nextValue: string) => void;
  isLoading?: boolean;
  wrapperClass?: string;
  view: "mobile" | "desktop";
  align?: "start" | "end";
  size?: "sm" | "lg";
}

const LanguageSelect: React.FC<ILanguageSelectProps> = ({
  value,
  options,
  onChange,
  isLoading = false,
  wrapperClass = "",
  align = "end",
  size = "sm",
  view,
}) => {
  const isMobile = view === "mobile";
  const currentLabel =
    options.find((option) => option.value === value)?.label ??
    value.toUpperCase();
  return (
    <Dropdown className={`${wrapperClass} dropdown-language`}>
      <Dropdown.Toggle
        variant="outline-secondary"
        size={size}
        disabled={isLoading || options.length <= 1}
        className={`dropdown-language text-uppercase text-text-primary border border-text-primary rounded-sm ${isMobile ? "fs-14 px-2" : "fs-16 px-4"}`}
      >
        {isLoading ? (
          <Spinner variant="primary" animation="border" size="sm" />
        ) : (
          <div
            className={`d-flex justify-content-between align-items-center ${isMobile ? "py-0" : "py-1"}`}
          >
            <span className="lg-sm">{currentLabel}</span>
            <ChevronDown className="dropdown-icon ms-1" />
          </div>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu
        align={align}
        style={
          {
            ["--bs-dropdown-min-width"]: isMobile ? "52px" : "75px",
          } as React.CSSProperties
        }
      >
        {options.map((option) => (
          <Dropdown.Item
            key={option.value}
            active={option.value === value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelect;
